import * as React from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import { Panes } from 'modules/core/components/Panes'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction from 'modules/core/lib/asyncAction'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import TimeoffAllowances from 'modules/timeoff/components/TimeoffAllowances'
import BasicTimeoffPolicyForm from 'modules/timeoff/lib/TimeoffPolicy/Basic'
import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

interface Props {
  policy: TimeoffPolicy | undefined
}

const BasicTimeoffPolicyInfo = ({ policy, children }: React.PropsWithChildren<Props>) => {
  const { navigation } = useNavigation()

  const attr = policy?.toJS() ?? {}
  const form = React.useRef(new BasicTimeoffPolicyForm(attr)).current

  const onSubmit = () => {
    if (!policy) {
      return
    }
    return asyncAction(() => form.save(policy))
  }

  const newAllowanceRoute = navigation.settings.timeoffPolicies.id.details.addAllowance.fullPath({
    id: policy?.attributes.id,
  })
  const renderAction = newAllowanceRoute && !hasFeature('payroll')

  return (
    <Box paddingTop="s48">
      <Panes direction="vertical">
        <Section.Form
          illustration="document-edit"
          title={i18n.t('settings.timeoff_policies.basic_information.basic.title')}
          description={i18n.t('settings.timeoff_policies.basic_information.basic.description')}
          onSubmit={onSubmit}
          isDirty={form.isDirty}
          submitLabel={i18n.t('common.submit')}
          paddingX="s0"
          paddingY="s0"
        >
          <Text label={i18n.t('settings.timeoff_policies.fields.name')} field={form.get('name')} />
          <Text
            label={i18n.t('settings.timeoff_policies.fields.description')}
            field={form.get('description')}
          />
        </Section.Form>
        <Section
          illustration="holidays-event-date"
          title={i18n.t('settings.timeoff_policies.basic_information.allowance.title')}
          description={i18n.t('settings.timeoff_policies.basic_information.allowance.description')}
          action={
            renderAction
              ? {
                  to: newAllowanceRoute,
                  label: i18n.t(
                    'settings.timeoff_policies.basic_information.timeoff.add_allowance'
                  ),
                }
              : undefined
          }
          paddingX="s0"
          paddingY="s64"
        >
          <TimeoffAllowances policyId={policy?.attributes.id} />
        </Section>
        {children}
      </Panes>
    </Box>
  )
}

export default observer(BasicTimeoffPolicyInfo)
